import { makeStyles, tokens } from "@fluentui/react-components";

export const useMessageRowStyles = makeStyles({
  retryButton: {
    marginTop: "8px",
    alignSelf: "flex-end",
  },
  errorMessage: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  messageContainer: {
    position: "relative",
  },
  retryIconButton: {
    marginLeft: "8px",
    minWidth: "32px",
    height: "32px",
  },
  statusIndicator: {
    fontSize: tokens.fontSizeBase200,
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  sendingText: {
    color: tokens.colorNeutralForeground3,
  },
});
